import {useEffect} from 'react'

import {setLocation} from '../../redux/actions/ui/index.js'
import {dispatch} from '../../store.js'

export default function HashListener() {
  useEffect(() => {
    function onHashChange(event) {
      const newURL = event.newURL || window.location.href
      // the real hash changed

      // get the hash
      const urlParts = newURL.split('#')

      // format it consistently
      const hash = `#${urlParts[1] || ''}`

      dispatch(setLocation(hash))
    }

    window.addEventListener('hashchange', onHashChange)

    return () => {
      window.removeEventListener('hashchange', onHashChange)
    }
  }, [])
}
